// extracted by mini-css-extract-plugin
module.exports = {"section":"Approach_section__1rDJj","body":"Approach_body__vGdrf","title":"Approach_title__30s8i","subtitle":"Approach_subtitle__22L9g","button":"Approach_button__s1PeL"};